export const localStorageConstants = {
  REFRESH_TOKEN: 'refreshToken',
  REFRESH_TOKEN_EXPIRY: 'refreshTokenExpiry',
  ACCESS_TOKEN: 'accessToken',
  USER: 'user',
  ACTIVE_ACCOUNT_ID: 'activeAccountId',
};
